import { appClient } from '@/lib/appwrite/appClient';
import {
  APP_COLLECTIONS,
  AppReport,
  BankAccounts,
  ReportType,
} from '@polybank/shared';
import { ID } from 'appwrite';
import { aiService } from './ai-service';

/**
 * Service for managing reports
 */
export class ReportsService {
  async generateQuery(naturalLanguageQuery: string) {
    return aiService.generateQuery(naturalLanguageQuery);
  }

  async deleteReport(reportId: string) {
    return appClient.tables.typed.deleteRow(APP_COLLECTIONS.REPORTS, reportId);
  }

  async createReport(data: {
    name: string;
    description: string;
    accountId: string;
    dateStart: string;
    dateEnd: string;
    type: ReportType;
    categoryIds: string[];
  }): Promise<AppReport> {
    return appClient.tables.typed.upsertRow(
      APP_COLLECTIONS.REPORTS,
      ID.unique(),
      {
        name: data.name.trim(),
        description: data.description.trim(),
        bankAccounts: [{ $id: data.accountId } as BankAccounts],
        date_from: data.dateStart,
        date_to: data.dateEnd,
        type: data.type,
        last_generated: new Date().toISOString(),
        meta: JSON.stringify({
          categoryIds: data.categoryIds,
        }),
      }
    );
  }
}

// Export singleton instance
export const reportsService = new ReportsService();
